;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { PropsWithChildren } from "react"

export default function LeftSideContainer({ children }: PropsWithChildren) {
  return (
    <div className="max-w-[600px] min-[800px]:max-w-none w-full min-[1100px]:w-[66%] h-full bg-[#EEEDED] flex items-center justify-center rounded-[20px_20px_0_0] min-[1100px]:rounded-[20px_0_0_20px] ">
      <div className="px-[10px] min-[600px]:px-[20px]">{children}</div>
    </div>
  )
}
